const domainDev = 'http://1.13.20.194/admin'


const domainProduct = '/admin' // 生产环境域名

export default {
  baseUrl: process.env.NODE_ENV === "production" ? domainProduct : domainDev, // 域名
  uploadImg: process.env.NODE_ENV === "production" ? domainProduct + '/sys/upload/' : domainDev + '/sys/upload/',
  uploadImgUrl: process.env.NODE_ENV === "production"
    ? "https://yuyi-1301954635.cos.ap-guangzhou.myqcloud.com/"
    : "https://yuyi-1301954635.cos.ap-guangzhou.myqcloud.com/"  // 区分开发模式和发布模式
}